import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SnColorPalette } from '@lib/common/types';
import { t } from '@lib/translation';

interface IInfoDialogButtonConfig {
  text: string;
  color?: SnColorPalette;
}

export interface ISnInfoDialogConfig {
  title?: string;
  icon?: string;
  message: string;
  confirmButton?: string | IInfoDialogButtonConfig;
  cancelButton?: string | IInfoDialogButtonConfig;
}

@Component({
  selector: 'sn-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialogComponent {
  public readonly title: string;
  public readonly message: string;
  public readonly icon: string;

  public readonly confirmButton: IInfoDialogButtonConfig;
  public readonly cancelButton: IInfoDialogButtonConfig;

  constructor(
    private readonly _matDialogRef: MatDialogRef<InfoDialogComponent | any>,
    @Inject(MAT_DIALOG_DATA) config: ISnInfoDialogConfig,
  ) {
    this.title = config.title;
    this.message = config.message;
    this.icon = config.icon;
    this.confirmButton = this._initConfirmButton(config.confirmButton);
    this.cancelButton = this._initCancelButton(config.cancelButton);
  }

  public confirm(): void {
    this._matDialogRef.close(true);
  }

  public cancel(): void {
    this._matDialogRef.close(false);
  }

  private _initConfirmButton(config?: string | IInfoDialogButtonConfig): IInfoDialogButtonConfig {
    if (!config) {
      return { text: t('common.ok'), color: 'success' };
    } else if (typeof config === 'string') {
      return { text: config, color: 'success' };
    }

    return config;
  }

  private _initCancelButton(config?: string | IInfoDialogButtonConfig): IInfoDialogButtonConfig {
    if (!config) {
      return { text: t('common.cancel') };
    } else if (typeof config === 'string') {
      return { text: config };
    }

    return config;
  }
}
